import { Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import './style.css';
import Homepage from './pages/Homepage';
import AddBook from './pages/AddBook';
import EditBook from './pages/EditBook';

function App() {
  return (
    <>
    <Header/>
    <Routes>
      <Route path='/' element={<Homepage/>}/>
      <Route path='/add-new-book' element={<AddBook/>}/>
      <Route path='/edit/:id' element={<EditBook/>}/>
    </Routes>
    </>
  );
}

export default App;
